export const ANZAHL_TAGE_OFFENE_TICKETS_NBWB = 1;

export const DIALOG_STEP_HOME = 0;
export const DIALOG_STEP_CREATE = 1;
export const DIALOG_STEP_VERIFY = 2;
